import React from "react";

const CorrectAudio = () => {
  return (
    <audio id="backgroundMusic" autoPlay>
      <source src="/audio/Correct.mp3" type="audio/mp3" />
    </audio>
  );
};

export default CorrectAudio;
